import React from 'react'
import PropTypes from 'prop-types'

const FormattedRadioButton = ({ checked }) => (
  <div className="flex rounded-full border border-grey-dark bg-white min-w-6 h-6 mr-2 items-center justify-center">
    {checked && (
      <div className="rounded-full bg-harbor w-3 h-3" />
    )}
  </div>
)

FormattedRadioButton.propTypes = {
  checked: PropTypes.bool
}

FormattedRadioButton.defaultProps = {
  checked: false
}

export default FormattedRadioButton